import React, {FC} from 'react';

import QuestionCurrency from '../../components/QuestionCurrency';

import styles from './styles.module.scss';

const StepIncome: FC = () => (
  <div className={styles.stepIncome}>
    <QuestionCurrency
      field="annualIncome"
      label="Annual pre-tax income"
      hintText="Feel free to estimate."
    />
    <QuestionCurrency
      field="cashSavings"
      label="Cash in savings or checking accounts"
      hintText="Not investments, just cash you can access today."
    />
  </div>
);

export default StepIncome;
